import React, { Component } from 'react';
import { Header, Segment, Table } from 'semantic-ui-react';
import { EUserLevels, IUser, userRoleNiceName } from '@relab/alstom-ptw-shared';

import { UserDeleteModal } from './UserDeleteModal';
import { UserEditModal } from './UserEditModal';
import { TranslationComponent } from '../TranslationComponent';

function userLevelNiceName(userLevel: EUserLevels): string {
  switch (userLevel) {
    case EUserLevels.Admin:
      return 'Admin';
    case EUserLevels.User:
      return 'User';
    default:
      return '';
  }
}

interface UsersListComponentProps {
  users: IUser[];
}

interface UsersListComponentState {
  column: string;
  sortedUsers: IUser[];
  direction: 'descending' | 'ascending';
}

export class UsersListComponent extends Component<UsersListComponentProps> {
  state: UsersListComponentState = {
    column: 'email',
    sortedUsers: [],
    direction: 'ascending',
  };

  componentDidUpdate(prevProps: Readonly<UsersListComponentProps>) {
    if (this.props.users !== prevProps.users) {
      this.setState({
        sortedUsers: this.props.users,
      });
    }
  }

  handleSort = (clickedColumn: string) => () => {
    const { users } = this.props;
    const { column, sortedUsers, direction } = this.state;

    if (column !== clickedColumn) {
      const sortedUsers = users.sort((a: any, b: any) =>
        a[clickedColumn]?.toUpperCase() > b[clickedColumn]?.toUpperCase() ? -1 : 1
      );

      this.setState({
        column: clickedColumn,
        sortedUsers,
        direction: 'ascending',
      });

      return;
    }

    this.setState({
      sortedUsers: sortedUsers.reverse(),
      direction: direction === 'ascending' ? 'descending' : 'ascending',
    });
  };

  render() {
    const { column, direction, sortedUsers } = this.state;

    return (
      <Segment>
        <Header as="h2">
          <TranslationComponent stringKey={'User list ({{length}})'} values={{ length: sortedUsers.length }} />
        </Header>

        <Table sortable celled fixed>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell sorted={column === 'name' ? direction : null} onClick={this.handleSort('name')}>
                <TranslationComponent stringKey={'Name'} />
              </Table.HeaderCell>
              <Table.HeaderCell sorted={column === 'email' ? direction : null} onClick={this.handleSort('email')}>
                <TranslationComponent stringKey={'Email'} />
              </Table.HeaderCell>
              <Table.HeaderCell sorted={column === 'role' ? direction : null} onClick={this.handleSort('role')}>
                <TranslationComponent stringKey={'Type'} />
              </Table.HeaderCell>
              <Table.HeaderCell sorted={column === 'role' ? direction : null} onClick={this.handleSort('role')}>
                <TranslationComponent stringKey={'Role'} />
              </Table.HeaderCell>
              <Table.HeaderCell />
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {sortedUsers.map((user) => (
              <Table.Row key={user.email}>
                <Table.Cell>{user.name}</Table.Cell>
                <Table.Cell>{user.email}</Table.Cell>
                <Table.Cell>{userLevelNiceName(user.userLevel)}</Table.Cell>
                <Table.Cell>{user.userRoles?.map(userRoleNiceName).join(', ')}</Table.Cell>
                <Table.Cell textAlign="right">
                  <UserEditModal user={user} />
                  <UserDeleteModal user={user} />
                </Table.Cell>
              </Table.Row>
            ))}
          </Table.Body>
        </Table>
      </Segment>
    );
  }
}
